/**
 * @author Abhishek
 * @description Component to get value from source and display in the textbox
 */

import * as React from "react";
import { connect } from "react-redux";
import IProps from "./IProps";
import Label from "../../components/Label";
import ErrorMessage from "../../components/ErrorMessage";
import { bindActionCreators } from "redux";
import * as dynamicFormActionCreators from "../../components/DynamicForm/actionCreators";
import { validationCheck } from "../../utils/validation";
import {
    getDataFromStore,
    checkForReadOnly,
    specialCharacterCheck,
    dropCheck,
    preventSpecialCharacters,
    getPriceCheckDetails,
} from "../../utils/utils";
/**
 * @interface IState
 * @ignore
 */
interface IState {
    dataSources?: string[];
    value?: any;
    error?: any;
}

/**
 * @class DynamicField
 * @description This component renders the input field for zipcode
 * and the city where the fields can be updated by the user as well as the type ahead component through redux store
 * @category Widgets
 */
class DynamicField extends React.Component<IProps, IState> {
    constructor(props) {
        super(props);
        this.state = {
            dataSources: [],
            value: this.props.value || "",
            error: { error: false, errorMessage: [] },
        };
        this.onInputChange = this.onInputChange.bind(this);
        this.onBlurCheck = this.onBlurCheck.bind(this);
    }

    /**
     * @function  componentDidMount
     * @param
     * @description This will basically check if the value is there in the props
     * then then you need to update it, using on change method
     * @ignore
     */
    componentDidMount() {
        const { value, schema } = this.props;
        if (value) {
            this.onInputChange("", value);
        }
        // check if the datasource has length then call method and get the value
        else if (schema.const && schema.const.dataSource.length > 0) {
            this.setState({ dataSources: schema.const.dataSource }, () => {
                // destruct the patern and fetch the value.
                const updatedValue = getDataFromStore(schema.const.dataSource, this.props, this.state.value);
                if (updatedValue != undefined) {
                    this.setState({ value: updatedValue }, () => {
                        this.props.onChange(value);
                    });
                }
            });
        }
    }
    /**
     * @function componentDidUpdate
     * @param nextProps
     * @param nextState
     * @description This method is not called for the initial render.Using this as an opportunity
     * to operate on the DOM when the component has been updated. This is also a good place to do network requests as
     * long as you compare the current props to previous props
     * Checking the data source if not equal then we need to change UI again
     * @ignore
     *
     */
    componentDidUpdate(nextProps: any, nextState: any) {
        const { schema, warrantyData, value } = this.props;
        if (nextProps.schema.const.family !== this.props.schema.const.family) {
            this.setState({
                error: { error: false, errorMessage: [] },
            });
        }
        if ((!nextProps.warrantyData || Object.keys(nextProps.warrantyData).length === 0) && warrantyData) {
            if (value) {
                this.onInputChange("", value);
            }
        } else {
            const updatedValue = getDataFromStore(schema.const.dataSource, this.props, this.state.value);
            if (updatedValue != undefined) {
                this.setState({ value: updatedValue }, () => {
                    this.props.onChange(updatedValue);
                });
            }
            if (nextProps.value !== this.props.value) {
                this.setState(
                    {
                        error: { error: false, errorMessage: [] },
                    },
                    () => {
                        this.fieldClicked();
                    }
                );
            }
        }
    }

    /**
     * @function onInputChange
     * @param
     * @description
     *      1. On change set the value and and update the store
     *      2. On change, validate the targeted value with that comming in from the errorSchema
     * @ignore
     */
    onInputChange(e, value) {
        const { id, buildingAddress, mailAddress, onChange } = this.props;
        const { selectAddress } = this.props.dynamicFormActions;
        const inputValue = value || e.target.value;
        /*// Comment below code, due to validate the same on blur
        const { family } = this.props.schema.const;
        const { errorSchema } = this.props;
        const fieldId = this.props.id.split("_");
        const fieldName = this.props.id.split("_")[fieldId.length - 1];
        const validationError = validationCheck(inputValue, fieldName, family, errorSchema);*/
        let label = this.props.label.toLowerCase();
        if (label == "zip code" || label == "postal code") label = "zip";
        if (id.includes("mailWarrantyInfo")) {
            // Note this is a temporary fix as we have plan to introduce the chages for typeahead
            // which will have the dependency name and feildtype
            mailAddress[label] = inputValue;
            // keeping the changes for refernce
            selectAddress({ key: "mailAddress", payload: mailAddress, label: label });
            /*// Comment below code, due to validate the same on blur
            if (validationError.error) {
                this.setState({
                    error: validationCheck(inputValue, fieldName, family, errorSchema),
                });
            }*/
            onChange(inputValue);
        } else {
            // Note this is a temporary fix as we have plan to introduce the chages for typeahead
            // which will have the dependency name and feildtype
            buildingAddress[label] = inputValue;
            // keeping the changes for refernce
            selectAddress({ key: "buildingAddress", payload: buildingAddress, label: label });
            /*// Comment below code, due to validate the same on blur
            if (validationError.error) {
                this.setState({
                    error: validationCheck(inputValue, fieldName, family, errorSchema),
                });
            }*/
            onChange(inputValue);
        }
    }

    /**
     * @function onBlurCheck
     * @param event
     * @description
     *      1: Validates the targeted value with that comming in from the errorSchema
     * @ignore
     */
    onBlurCheck(event) {
        const { family } = this.props.schema.const;
        const { errorSchema } = this.props;
        const id = this.props.id.split("_");
        const fieldName = this.props.id.split("_")[id.length - 1];
        const validationError = validationCheck(event.target.value, fieldName, family, errorSchema);
        if (validationError && validationError.error) {
            this.setState({
                error: validationCheck(event.target.value, fieldName, family, errorSchema),
            });
        }
    }
    fieldClicked = () => {
        const { removeFieldIdFromStore } = this.props.dynamicFormActions;
        removeFieldIdFromStore(this.props.id);
    };

    // onInputBoxKeyDown = (evt) => {
    //     ["?", "<", ">", "&", '"', "(", ")", "#", "%", ";", "+"].includes(evt.key) && evt.preventDefault();
    // };

    // specialCharacterCheck = (e) => {
    //     const pastedData = e.clipboardData.getData("Text");
    //     const regSpclChar = /[\^<>&"()#%;+?]/;
    //     if (regSpclChar.test(pastedData)) {
    //         e.preventDefault && e.preventDefault();
    //         return false;
    //     }
    // };
    // dropCheck = (ev) => {
    //     const src = window.getSelection().toString();
    //     const regSpclChar = /[\^<>&"()#%;+?]/;
    //     if ((src && regSpclChar.test(src)) || src === "") {
    //         ev.preventDefault && ev.preventDefault();
    //         return false;
    //     }
    // };

    /**
     * @function render
     * @param
     * @description Render the dom
     */
    render() {
        const { value, schema, id, isSubmittedForm, errorDetails, errorSchema } = this.props;
        const { error } = this.state;
        const { family, fieldName } = getPriceCheckDetails(errorSchema, schema, id);
        return (
            <>
                <Label schema={schema} />
                <div
                    className={
                        (this.state.error && this.state.error.error && this.state.error.errorMessage.length > 0) ||
                        (this.props.errorDetails[id] && this.props.errorDetails[id].length > 0)
                            ? "error-boundary inputbox-rectangle"
                            : "inputbox-rectangle"
                    }
                >
                    <input
                        onClick={this.fieldClicked}
                        type="text"
                        value={value}
                        tabIndex={schema.const.tabIndex}
                        placeholder={schema.const && schema.const.placeholder && schema.const.placeholder}
                        onKeyDown={preventSpecialCharacters}
                        onChange={(e) => {
                            this.onInputChange(e, "");
                        }}
                        onBlur={(e) => this.onBlurCheck(e)}
                        className="gaf-inputBox"
                        id={id}
                        disabled={checkForReadOnly(schema.const, isSubmittedForm)}
                        onPaste={(e) =>
                            specialCharacterCheck(
                                e,
                                { value: e.target["value"], fieldName, family, errorSchema },
                                schema.type
                            )
                        }
                        onDrop={(e) => dropCheck(e, schema.type)}
                    />
                </div>
                <ErrorMessage errorDetails={errorDetails} errorState={error} propId={id} />
            </>
        );
    }
}

export function mapStateToProps(state) {
    return {
        buildingAddress: state.dynamicFormInfo.global.buildingAddress,
        mailAddress: state.dynamicFormInfo.global.mailAddress,
        errorDetails: state.dynamicFormInfo.errorDetails || {},
        isSubmittedForm: state.adminData.isSubmittedForm,
        warrantyData: state.dynamicFormInfo.layoutResponse.WarrantyData,
    };
}

export function mapDispatchToProps(dispatch) {
    return {
        dynamicFormActions: bindActionCreators(dynamicFormActionCreators, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(DynamicField);
